import styled from 'styled-components';
import { TextArea } from 'components/ProfileUIComponents';

export const StyledTextArea = styled(TextArea)`
  overflow: hidden;
  resize: vertical;
  margin-top: 8px;
  padding: 8px;
`;
